import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getPractice = async () => {
    const res = await api.get(`/Clinician/Practice`);

    return {
        ...res.data,
        isAddressSameAsPersonal: res.data.isAddressSameAsPersonal === 1,
        isGroupPractice: res.data.isGroupPractice === 1,
    };
};

export const usePractice = () => {
    return useQuery({
        queryKey: ["practice"],
        queryFn: getPractice,
        retry: 3,
        staleTime: Infinity,
    });
};
